import React from 'react'
import { Card, Box, Typography, Stack } from "@mui/material";

const TotalProjectStatusCard = ({
    count,
    title,
    gradient,
    textColor
}) => {
    return (
        <Card
            sx={{
                height: '45px',
                borderRadius: 3,
                overflow: "hidden",
                p: 1,
                color: textColor,
                background: gradient,
                justifyContent: 'center',
            }}
        >
            <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
            }}>
                <Typography
                    variant="body2"
                    sx={{ zIndex: 1, position: "relative", fontWeight: "bold", fontSize: '14px' }}
                >
                    {title} : {count}
                </Typography>
            </Box>
        </Card>
    )
}

export default TotalProjectStatusCard
